// src/genql/runtime/_aliasing.ts
var aliasSeparator = "__alias__";
function replaceSystemAliases(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => replaceSystemAliases(item));
  }
  const newObj = {};
  for (const [key, value] of Object.entries(obj)) {
    if (key.includes(aliasSeparator)) {
      const [_prefix, ...rest] = key.split(aliasSeparator);
      const newKey = rest.join(aliasSeparator);
      newObj[newKey] = replaceSystemAliases(value);
    } else {
      newObj[key] = replaceSystemAliases(value);
    }
  }
  return newObj;
}

export {
  aliasSeparator,
  replaceSystemAliases
};
